import CurrentGoal from '@client/models/store/goal/current';
import moment from 'moment';
import {Constants} from '@client/util/constants';

export default class Goal {
  constructor() {
    this.toAdd = null;
    this.selectOptions = [];
    this.toAddPortfolio = null;
    this.current = new CurrentGoal();
    this.totalValue = null;
    this.totalCash = null;
    this.all = [];
    this.isGoalSelectionLoaded = false;
    this.currentGoal = null;
  }

  static log(msg) {
    if (window.logTargetCalcs) {
      console.log(msg);
    }
  }

  static getDob(user) {
    let dob = moment(Constants.DEFAULT_BIRTH_DATE, 'YYYY-MM-DD');

    if (user.birthdate) {
      dob = moment(user.birthdate, 'YYYY-MM-DD');
    }

    // we actually dont care about the date in this situation
    // so change it to the first of the month
    dob.date(1);

    return dob;
  }

  static getPreRetirementTarget(goal, user) {
    // we are saving up for retirement
    // lets calculate when that will be
    const dob = this.getDob(user);

    this.log(`Your DOB is: ${dob.format('MM-DD-YYYY')}`);

    const target = dob.add(goal.retirementAge, 'years');

    this.log(`Add ${goal.retirementAge} years to that`);

    this.log(`Your target is ${target.format('MM-DD-YYYY')}.`);

    return target;
  }

  static getPostRetirementTarget(goal, user) {
    // the user already retired, and investing that income
    // the goal MUST be an investment framework so we know how long it will take
    const dob = this.getDob(user);

    this.log(`Your DOB is: ${dob.format('MM-DD-YYYY')}`);

    this.log(`You retired at age: ${goal.retirementAge}`);

    this.log(`Add ${goal.retirementAge} years to your DOB(${dob.format('MM-DD-YYYY')})`);

    const retirementDate = dob.add(goal.retirementAge, 'years');

    this.log(`And you get the date you retired: ${retirementDate.format('MM-DD-YYYY')}`);

    this.log(`Our glide path is ${goal.goalLengthMonths} months`);

    this.log(`Add that to our retirement date (${retirementDate.format('MM-DD-YYYY')})`);

    const target = retirementDate.add(goal.goalLengthMonths, 'months');

    this.log(`And you get your target date: ${target.format('MM-DD-YYYY')}`);

    return target;
  }

  static getTargetFromAge(goal, user) {
    if (goal.retirementAge === null) {
      return null;
    }

    let targetDate = null;

    if (this.isPreRetirement(goal)) {
      targetDate = this.getPreRetirementTarget(goal, user);
    }

    if (this.isPostRetirement(goal)) {
      targetDate = this.getPostRetirementTarget(goal, user);
    }

    if (targetDate === null) {
      // this shouldnt happen
      return moment(goal.targetDate).format('YYYYMMDD');
    }

    // dont allow past dates
    return targetDate < moment() ? moment().format('YYYY-MM-DD') : targetDate.format('YYYY-MM-DD');
  }

  static getTargetDate(goal, user) {
    if (this.isAgeType(goal)) {
      return this.getTargetFromAge(goal, user);
    }

    return goal.targetDate;
  }

  static isAgeType(goal) {
    if (goal === null) {
      return false;
    }

    if (goal.displayType === 2 || goal.displayType === 3) {
      return true;
    }

    return false;
  }

  static isTargetType(goal) {
    if (goal === null) {
      return false;
    }

    if (goal.displayType === 1) {
      return true;
    }

    return false;
  }

  static isEmptyType(goal) {
    if (goal.displayType === 0) {
      return true;
    }

    return false;
  }

  static isPreRetirement(goal) {
    if (goal.displayType === 2) {
      return true;
    }

    return false;
  }

  static isPostRetirement(goal) {
    if (goal.displayType === 3) {
      return true;
    }

    return false;
  }

  static setTarget(goal, targetValue, user) {
    if (Goal.isAgeType(goal)) {
      // browser compatibility issue
      if (targetValue && targetValue.length > 2) {
        // eslint-disable-next-line no-param-reassign
        targetValue = moment().diff(targetValue, 'years');
      }

      // eslint-disable-next-line no-param-reassign
      goal.retirementAge = targetValue;
      // eslint-disable-next-line no-param-reassign
      goal.targetDate = Goal.getTargetDate(goal, user);
    }

    if (Goal.isTargetType(goal)) {
      // eslint-disable-next-line no-param-reassign
      goal.targetDate = targetValue;
    }
  }

  static getPretext(goal) {
    if (Goal.isPreRetirement(goal)) {
      return 'I plan to retire at age';
    }

    if (Goal.isPostRetirement(goal)) {
      return 'I retired at age';
    }

    return '';
  }

  static getTargetDateWording(goal) {
    if (Goal.isPreRetirement(goal) && goal.retirementAge) {
      return `Target Age: ${goal.retirementAge}`;
    }

    if (Goal.isPostRetirement(goal)) {
      return 'Target Date: N/A';
    }

    if (Goal.isAgeType(goal)) {
      return `Target Age: ${goal.retirementAge}`;
    }

    return `Target Date: ${Goal.getValidDate(goal.target_date)}`;
  }

  // eslint-disable-next-line camelcase
  static getValidDate(targetDate) {
    const momentDate = moment(targetDate, 'YYYY-MM-DD');
    const momentMonth = moment(targetDate).format('YYYY-MM');

    if (momentDate.isValid() && momentMonth >= moment().format('YYYY-MM')) {
      return moment(targetDate, 'YYYY-MM-DD').format('MM/YYYY');
    }

    return 'N/A';
  }
}
